import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './FeaturesSection.css';
import { useLoading } from '../../contexts/LoadingContext';

const FeaturesSection = () => {
  const { markComponentLoaded } = useLoading();
  const [features, setFeatures] = useState([]);
  const [title, setTitle] = useState('Powerful Features');
  const [subtitle, setSubtitle] = useState('Everything you need for comprehensive attendance management');

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        // Get features
        setFeatures(response.data.data.features || []);

        // Get section content
        const sections = response.data.data.sections || [];
        const featuresSection = sections.find(s => s.section_key === 'features');

        if (featuresSection && featuresSection.content) {
          const titleContent = featuresSection.content.find(c => c.content_key === 'features_title');
          const subtitleContent = featuresSection.content.find(c => c.content_key === 'features_subtitle');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);
        }
      }
    } catch (error) {
      console.error('Failed to fetch features:', error);
    } finally {
      markComponentLoaded('FeaturesSection');
    }
  };

  // Default icon mapping for common features
  const getDefaultIcon = (title, index) => {
    const titleLower = title?.toLowerCase() || '';

    if (titleLower.includes('android') || titleLower.includes('ios') || titleLower.includes('app')) return '📱';
    if (titleLower.includes('geofenc')) return '📍';
    if (titleLower.includes('facial') || titleLower.includes('face')) return '👤';
    if (titleLower.includes('liveness')) return '✓';
    if (titleLower.includes('report') || titleLower.includes('analytic')) return '📊';
    if (titleLower.includes('offline') || titleLower.includes('sync')) return '🔄';
    if (titleLower.includes('leave') || titleLower.includes('holiday')) return '📅';
    if (titleLower.includes('admin') || titleLower.includes('portal')) return '⚙️';

    // Fallback icons
    const defaultIcons = ['🎯', '⭐', '🚀', '💡', '🔒', '⚡', '🎨', '🔔'];
    return defaultIcons[index % defaultIcons.length];
  };

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-icon">
                {feature.icon_image ? (
                  <img src={feature.icon_image} alt={feature.title} />
                ) : feature.icon_class ? (
                  <i className={feature.icon_class}></i>
                ) : (
                  <span>{getDefaultIcon(feature.title, index)}</span>
                )}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
